<template>
  <div class="table-dark-bg box-shadow cart-table-wrapper pt-3">
    <div class="order-summary">
      <b-row class="px-3 pb-1">
        <b-col>
          <h6 class="mb-0 fw-normal" v-text="Title"></h6>
        </b-col>
        <b-col class="col text-right">
          <h6
            class="mb-0 fw-normal"
            v-if="state.billing.billing.invoice.data == ''"
            v-text="itemList.length + ' Item(s)'"
          ></h6>
          <!-- transTypeDeposit || transTypeRefundNote
                ? state.billing.billing.order.summary.items.length +
                  ' ' +
                  'Item(s)'
                : state.billing.billing.total_qty + ' ' + 'Item(s)' -->
          <h6
            class="mb-0 fw-normal"
            v-if="state.billing.billing.invoice.data != ''"
          >
            {{ Math.round(state.billing.billing.invoice.summary.item_qty) }}
            Item(s)
          </h6>
        </b-col>
      </b-row>

      <!-- <b-row>
        <b-col cols="4">
          <label>Bill Remarks</label>
        </b-col>
        <b-col cols="8">
          <p class="mb-0">{{BillRemarks}}</p>
        </b-col>
      </b-row>
      <hr>-->

      <div class="order-items mt-2">
        <b-table
          striped
          :fields="fields"
          :items="itemList"
          class="table cart-table table-dark px-5"
          style="line-height: 16px;"
        >
          <template v-slot:cell(#)="data" class="sticky">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(p_name)="data">
            <div
              class="d-flex flex-column"
              v-b-tooltip.hover
              :title="data.item.p_name.length > 25 ? data.item.p_name : ''"
            >
              <span v-text="splitText(data.item.p_name, 25)" />
              <span class="text-muted" v-text="data.item.barcode" />
            </div>
          </template>
          <template v-slot:cell(voucher_code)="data">
            <span v-text="helper.hideMiddleText(data.item.voucher_code)"></span>
          </template>
          <template v-slot:cell(mobile)="data">
            <span
              v-text="data.item.mobile == null ? '-' : data.item.mobile"
            ></span>
          </template>
          <template v-slot:cell(tax_amount)="data">
            <span v-text="currencySymbol"></span>
            <span
              v-text="
                data.item.tax_amount == null ? '0.00' : data.item.tax_amount
              "
            ></span>
          </template>
          <template v-slot:cell(total)="data">
            <div v-html="currencySymbol + formatAmount(data.item.total)" />
          </template>
          <template v-slot:cell(gift_value)="data">
            <span
              v-text="currencySymbol + formatAmount(data.item.gift_value)"
            />
          </template>
          <template v-slot:cell(sale_value)="data">
            <span
              v-text="currencySymbol + formatAmount(data.item.sale_value)"
            />
          </template>
          <template v-slot:cell(net_value)="data">
            <span
              v-text="currencySymbol + formatAmount(data.item.sale_value)"
            />
          </template>
          <template v-slot:cell(discount)="data">
            <span v-text="currencySymbol + formatAmount(data.item.discount)" />
          </template>
          <template v-slot:cell(unit_mrp)="data">
            <span v-text="currencySymbol + formatAmount(data.item.unit_mrp)" />
          </template>
          <template v-slot:cell(subtotal)="data">
            <span v-text="currencySymbol + formatAmount(data.item.subtotal)" />
          </template>
          <template v-slot:cell(tax)="data">
            <span v-text="currencySymbol + formatAmount(data.item.tax)" />
          </template>
        </b-table>

        <!-- <b-row
          class="mb-2 px-3"
          v-for="(item, id) in itemList"
          v-bind:key="item.name"
        >
          <b-col md="1" class="p-0 text-left">
            <span class="pr-0" v-text="id + 1"></span>
          </b-col>
          <b-col md="7" class="text-left order-summary-list">
            <ul class="p-0">
              <li v-text="item.p_name.slice(0, 18)"></li>
            </ul>
          </b-col>
          <b-col md="1" class="text-center p-0" v-text="item.qty"></b-col>
          <b-col
            md="3"
            class="text-right pr-0"
            v-text="currencySymbol + ' ' + item.total"
          >
          </b-col>
          <div class="clearfix"></div>
        </b-row> -->
      </div>

      <hr />

      <div class="card total-cart-amount border-0 px-3">
        <div class="card-body p-0">
          <!-- <div v-bar class="cart-total">
            <div>
              <b-row class="mb-1" v-for="summry in orderSummary" :key="summry.name">
                <div class="col light" v-if="summry.last == 0">
                  <p v-text="summry.display_text"></p>
                </div>
                <div class="col text-right pr-0" v-if="summry.last == 0">
                  <p>₹ {{ summry.value }}00</p>
                </div>
              </b-row>
 
            </div>
          </div>-->
          <div class="cart-total">
            <!-- <div class="row mb-1" v-for="cartInformation in cartInformations">
                        <div class="col light"><p>{{cartInformation.label}}</p></div>
                        <div class="col text-right"><p>{{cartInformation.Item}}</p></div>
            </div>-->
            <b-row
              class="mb-1"
              v-for="(summry, index) in orderSummary"
              :key="summry.name + index"
            >
              <div class="col light" v-if="summry.last == 0">
                <p v-text="summry.display_text" />
              </div>
              <div class="col text-right" v-if="summry.last == 0">
                <p>
                  {{ summry.sign != "" ? summry.sign : "" }}
                  {{ currencySymbol }}
                  {{ formatAmount(summry.value) }}
                </p>
              </div>
            </b-row>
            <!-- <div class="row mb-1">
              <div class="col light">
                <p>Subtotal</p>
              </div>
              <div class="col text-right">
                <p>₹ {{ state.billing.subtotal }}</p>
              </div>
            </div>-->
            <!-- <div class="row mb-1">
              <div class="col light">
                <p>Discount</p>
              </div>
              <div class="col text-right">
                <p>- ₹ {{ state.billing.discount }}</p>
              </div>
            </div>
            <div class="row mb-1">
              <div class="col light">
                <p>Taxes</p>
              </div>
              <div class="col text-right">
                <p>₹ {{ state.billing.taxes }}</p>
              </div>
            </div>
            <div class="row mb-1">
              <div class="col light">
                <p>Carry Bags</p>
              </div>
              <div class="col text-right">
                <p>₹ {{ state.billing.cart.carry_bag_total }}</p>
              </div>
            </div>-->
          </div>

          <b-row class="mt-3 total p-3">
            <div class="col light p-0">
              <p class="p-0 mt-1 mb-0" v-if="!refundMode">
                {{
                  state.billing.billing.invoice.summary == ""
                    ? orderSummary[orderSummary.length - 1].display_text
                    : "Amount Paid:"
                }}
              </p>
              <p class="p-0 mt-1" v-if="refundMode">Total Refund:</p>
              <!-- <p class="p-0 mt-1">Total Paid</p> -->
            </div>
            <div class="col text-right p-0">
              <h6
                class="mb-0 p-0"
                style="font-size: 1.3rem;"
                v-if="!layByStatus"
              >
                {{ currencySymbol }}
                {{
                  state.billing.billing.invoice.summary == ""
                    ? formatAmount(orderSummary[orderSummary.length - 1].value)
                    : formatAmount(
                        state.billing.billing.invoice.summary.amount_paid
                      )
                }}
              </h6>
              <h6
                class="mb-0 p-0"
                style="font-size: 1.3rem;"
                v-if="layByStatus"
              >
                {{ currencySymbol }}
                {{
                  state.billing.billing.order.summary != ""
                    ? formatAmount(state.billing.billing.total_payable)
                    : formatAmount(
                        state.billing.billing.invoice.summary.amount_paid
                      )
                }}
              </h6>
            </div>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as helper from "../helper";

export default {
  name: "order-summary",
  data() {
    return {
      Title: "Order Summary",
      id: 0,
      transaction_sub_type: "",
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    itemCount() {
      let name = "";
      if (this.state.billing.billing.invoice.data.data == "") {
        name = "order";
      } else {
        name = "invoice";
      }
      if (this.state.billing.billing[name].summary.item_qty != "") {
        return this.state.billing.billing[name].summary.item_qty;
      } else {
        return 0;
      }
    },
    itemList() {
      let name = "";
      if (this.state.billing.billing.invoice.data == "") {
        name = "order";
      } else {
        name = "invoice";
      }
      return this.state.billing.billing[name].summary.items;
    },
    orderSummary() {
      let name = "";
      if (this.state.billing.billing.invoice.data == "") {
        name = "order";
      } else {
        name = "invoice";
      }
      //   return this.state.billing.order.summary.summary;
      let data = [];
      this.state.billing.billing[name].summary.summary.map((item) => {
        if (item.name != "total_payable") {
          item.last = 0;
          data.push(item);
        } else {
          item.last = 1;
          data.push(item);
        }
      });
      return data;
      // this.$loading = false;
    },
    layByStatus() {
      if (this.state.billing.billing.invoice.data != "") {
        if (
          this.state.billing.billing.invoice.summary.amount_due != "0" ||
          parseFloat(this.state.billing.billing.invoice.summary.amount_due) != 0
        ) {
          return true;
        } else {
          return false;
        }
      } else if (this.state.billing.billing.order.data != "") {
        if (
          this.state.billing.billing.layBy_Amt != 0 ||
          this.state.billing.billing.layBy_Amt != ""
        ) {
          return true;
        } else {
          return false;
        }
      } else return false;
    },
    refundMode() {
      let check = false;
      if (this.state.billing.billing.refund_mode) {
        check = true;
      }
      return check;
    },
    transTypeDeposit() {
      let check = false;
      if (this.state.billing.billing.order.data.trans_sub_type == "Deposit-DN")
        check = true;
      return check;
    },
    transTypeRefundNote() {
      let check = false;
      if (
        this.state.billing.billing.order.data.trans_sub_type == "Refund-CN" ||
        this.state.billing.billing.order.data.trans_sub_type == "Credit-Note"
      )
        check = true;
      return check;
    },
    isGvSale() {
      return this.state.giftVoucher.isGvSale;
    },
    fields() {
      let temp = [];
      if (this.isGvSale)
        temp = [
          {
            key: "#",
            label: "#",
            class: "text-left w-2 pl-3",
          },
          {
            key: "voucher_sequence",
            label: "Voucher Seq.",
            class: "text-left w-10",
          },
          {
            key: "voucher_code",
            label: "Voucher Code",
            class: "text-center w-10",
          },
          {
            key: "mobile",
            label: "Phone Number",
            class: "text-center w-10",
          },

          {
            key: "gift_value",
            label: "Gift Value",
            class: "text-center w-10",
          },
          {
            key: "sale_value",
            label: "Sale Value",
            class: "text-center w-10",
          },
          {
            key: "tax_amount",
            label: "Taxes",
            class: "text-center w-10",
          },
          {
            key: "net_value",
            label: "Net Value",
            class: "text-right w-10",
          },
        ];
      else
        temp = [
          {
            key: "#",
            label: "#",
            class: "text-left w-2 pl-3",
          },
          {
            key: "p_name",
            label: "Product Name(s)",
            class: "text-left w-20",
          },
          {
            key: "qty",
            label: "Qty.",
            class: "text-center w-10",
          },
          {
            key: "unit_mrp",
            label: "Unit Price",
            class: "text-center w-10",
          },

          {
            key: "discount",
            label: "Discount",
            class: "text-center w-10",
          },
          // {
          //   key: "discount",
          //   label: "Discount",
          //   class: "text-center w-10",
          // },
          {
            key: "tax",
            label: "Tax",
            class: "text-center w-10",
          },
          {
            key: "subtotal",
            label: "Subtotal",
            class: "text-right w-10 pr-3",
          },
          {
            key: "total",
            label: "Net Price",
            class: "text-right w-10 pr-3",
          },
        ];
      return temp;
    },
    helper() {
      return helper;
    },
  },
};
</script>
<style lang="scss" scoped>
.order-summary ul {
  list-style-type: none;
  margin-bottom: 0px;
}
.order-summary h6 {
  font-size: 13px;
}
.total {
  // padding: 10px 15px;
  border: 1px #c0c0c0 solid;
  margin: 0px !important;
  border-radius: 5px;
}
.theme-light .total p {
  color: #606060 !important;
}
</style>
